import React, { Component } from 'react';
import { Card } from 'antd';
import { connect } from 'react-redux';
import DescriptionList from '@comm/DescriptionList';
import ModalApportion from '@comm/apportion/ModalApportionShow';
import { queryFilePreview } from '@api/pub/attachment';
import '../expenses.less';
import { queryBudgetGroupCandF } from '@api/finance/budget';

const { Description } = DescriptionList;
const budgetType = ['部门预算', '跨部门预算', '项目预算组'];
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dataItem: this.props.data,
      groupTip: {},
    };
  }

  componentDidMount() {
    const dataItem = this.props.data;
    !(+dataItem.budgetType === 1 || (dataItem.instance && dataItem.instance.status === 1)) &&
      this.getBudgetGroupCandF(dataItem.type);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  getBudgetGroupCandF = value => {
    queryBudgetGroupCandF({
      type: value,
      userUuid: this.state.dataItem.createUser,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          groupTip: res.data,
        });
      }
    });
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  render() {
    const { visible, dataItem, groupTip } = this.state;
    const files = dataItem.files || [];
    return (
      <div className="form-open">
        <Card title="报销详情">
          <DescriptionList size="large" col={3}>
            <Description term="报销类型">
              {this.findTypeName(dataItem.type)}
              <span className="lowspan">
                {groupTip && groupTip.groupName ? (
                  <span style={{ color: 'red' }}>
                    该费用类型,{groupTip.groupName}可用余额
                    <span>{groupTip.current || 0}</span>元
                    {groupTip.freeze ? (
                      <span>
                        , 冻结
                        <span>{groupTip.freeze || 0}</span>
                      </span>
                    ) : null}
                  </span>
                ) : null}
              </span>
            </Description>
            <Description term="报销金额">{dataItem.price}元</Description>
            <Description term="申请人员">{dataItem.createUserName}</Description>
            <Description term="预算来源">
              <a onClick={() => this.handleVisible(true)}>{budgetType[dataItem.budgetType]}</a>
            </Description>
            <Description term="报销公司">{dataItem.company}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="报销凭证">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.url}>
                      <a onClick={() => queryFilePreview(item)}> {item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="报销说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
        {visible ? (
          <ModalApportion
            onCancel={this.handleVisible}
            dataInfo={{}}
            dataItem={dataItem}
            visible={visible}
            onOk={this.handleOk}
          />
        ) : null}
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/finance/expenses/FormOpen.js